import { render, staticRenderFns } from "./OldShareLinkDialog.vue?vue&type=template&id=613bf970&scoped=true&"
import script from "./OldShareLinkDialog.vue?vue&type=script&lang=js&"
export * from "./OldShareLinkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613bf970",
  null
  
)

export default component.exports